import { getGridNumericOperators } from '@mui/x-data-grid-pro'
import { FILTER_OPERATOR_LABELS, RELEVANT_NUMBER_OPERATORS } from '@shared/constants/dataGrid'

import { ProfessionsColumnType } from '../professionsDataGridColumns'

export const trainingYearColumnModel: ProfessionsColumnType = {
  field: 'trainingYears',
  width: 125,
  filterOperators: getGridNumericOperators().filter((operator) =>
    Object.keys(RELEVANT_NUMBER_OPERATORS).includes(operator.value)).map((operator) => ({
    ...operator,
    type: 'number',
    label: FILTER_OPERATOR_LABELS[operator.value as keyof typeof FILTER_OPERATOR_LABELS]
  })),
  type: 'number',
  align: 'left',
  headerAlign: 'left',
  valueGetter: (params) => params.row.config?.trainingYears
}
